
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/mobile/view-your-receiving-address-to-send-funds-for-trading",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/mobile/view-your-receiving-address-to-send-funds-for-trading/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/mobile/view-your-receiving-address-to-send-funds-for-trading"])
      });
    }
  